export function getActiveHref() {
  const path = window.location.pathname + '/';
  return path.substring(0, path.indexOf('/', 1));
}

export function isHomePage() {
  return getActiveHref() == '/';
}
